import axios from 'axios'

// In dev, baseURL is relative so setupProxy.js forwards calls (and spoofs Origin for CORS).
// In prod, hit the real API directly.
const baseURL = process.env.NODE_ENV === 'production'
    ? 'https://api.jambhanilive.com/api/v1'
    : '/api/v1';

export const api = axios.create({
    baseURL,
    withCredentials: true,
})

// Global 401 handler: clear any client-side session and bounce to /login.
// This complements the AuthContext session-lifetime check so that
// server-side token expiry also forces a clean re-login flow.
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error?.response?.status === 401) {
            try { sessionStorage.clear(); } catch (_) { /* noop */ }
            if (typeof window !== 'undefined' && window.location.pathname !== '/login') {
                window.location.replace('/login');
            }
        }
        return Promise.reject(error);
    }
);
